import moment from 'moment'
import { triggerWarningToast } from '@resurs/midas-react'
import { ChannelType } from '../../models/channelType'
import { TransactionTypes } from '../../util/transactionConstants'
import {
  NOTIFY_DANGER,
  PAY_APPLY_APPLY_APPLICATION_SUCCESS,
  PAY_APPLY_AUTH_PAYMENT_SUCCESS,
  PAY_APPLY_CLEAR_REDIRECTION,
  PAY_APPLY_COAPPLICANT_INFO,
  PAY_APPLY_COST_LOADING,
  PAY_APPLY_CREATE_APPLICATION_SUCCESS,
  PAY_APPLY_CREATE_PAYMENT_SUCCESS,
  PAY_APPLY_CUSTOMER_TYPE,
  PAY_APPLY_DEBIT_PAYMENT_SUCCESS,
  PAY_APPLY_FAILED_IDENTIFICATION,
  PAY_APPLY_FAILED_SIGNING,
  PAY_APPLY_FATAL_ERROR,
  PAY_APPLY_FORM_SPEC,
  PAY_APPLY_FORM_SPEC_DATA,
  PAY_APPLY_GET_ADDRESS_INFO,
  PAY_APPLY_GET_APPLICATION,
  PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS,
  PAY_APPLY_GET_PAYMENT,
  PAY_APPLY_GET_PAYMENT_METHODS,
  PAY_APPLY_GET_PAYMENT_PER_MONTH,
  PAY_APPLY_GET_STORE_PAYMENT_METHODS,
  PAY_APPLY_GOVERNMENT_ID,
  PAY_APPLY_IDENTIFICATION_STATUS,
  PAY_APPLY_INIT,
  PAY_APPLY_MANUAL_IDENTIFICATION,
  PAY_APPLY_NEW_PAGE_LOADING,
  PAY_APPLY_ON_PAGE_LOADING,
  PAY_APPLY_PAPER_SIGN,
  PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS,
  PAY_APPLY_PENDING_APPLICATIONS_SUCCESS,
  PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS,
  PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS,
  PAY_APPLY_PUSHED_OUT_TO_CUSTOMER,
  PAY_APPLY_REDIRECTION_DATA_SUCCESS,
  PAY_APPLY_RESET_COST_ALTERNATIVES,
  PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD,
  PAY_APPLY_SELECT_PAYMENT_METHOD,
  PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD,
  PAY_APPLY_SET_CUSTOMER_TYPE,
  PAY_APPLY_SET_DEBIT_AMOUNT,
  PAY_APPLY_SET_DEBIT_REFERENCE,
  PAY_APPLY_SET_ORDER,
  PAY_APPLY_SET_PAGE,
  PAY_APPLY_SET_PAYMENT_DATA,
  PAY_APPLY_SET_PERIOD_OF_REPAYMENT,
  PAY_APPLY_SET_STEP,
  PAY_APPLY_SIGNING_STATUS,
  PAY_APPLY_SKIP_SIGNING,
  PUSH_OUT_AUTOMATIC_DEBIT,
} from './action-types'

import paymentEngineApi from '../../api/payment-engine-api'
import paymentMethodsApi from '../../api/payment-methods-api'
import paymentMethodsPricingServiceApi from '../../api/payment-methods-pricing-service-api'
import customerFinderServiceApi from '../../api/customer-finder-service-api'
import agreementServiceApi from '../../api/agreement-service-api'
import unusedApplicationsApi from '../../api/unused-applications-api'

import { getText } from '../../internal/TextLabels'

import { PayApplyType } from '../../models/payapply'
import {
  isEnabledPspPaymentMethod,
  isExistingAccountPaymentMethod,
  isExistingPartPayment,
  isResursPaymentMethod,
  PaymentMethods,
  PaymentMethodsStatuses,
} from '../../models/payment-methods'

import {
  createApplicationRequest,
  createInvoiceRequest,
  createPaymentRequest,
  debitPaymentRequest,
} from '../../api/request-builder/payment-engine-request-builder'

import { isUserResursAdmin, request } from './auth-actions'
import { notify } from './notification-actions'
import {
  genericError,
  silentError,
  unableToRetrievePendingApplicationError,
} from './action-utils'
import {
  CustomerTypeModel,
  StepModel,
} from '../../pages/PayApply/models/private-models'
import { ApplicationStatus } from '../../models/application-status'
import representativeServiceApi from '../../api/representative-service-api'
import {
  getRepresentativeId,
  getStoreId,
  isFranchiseeOrNoRelations,
} from '../../util/helpers'

const setGovernmentId = response => ({
  type: PAY_APPLY_GOVERNMENT_ID,
  response,
})

const setCustomerType = customerType => ({
  type: PAY_APPLY_SET_CUSTOMER_TYPE,
  customerType,
})

const setCoApplicantInfo = response => ({
  type: PAY_APPLY_COAPPLICANT_INFO,
  response,
})

const getAddressInfoSuccess = response => ({
  type: PAY_APPLY_GET_ADDRESS_INFO,
  response,
})

const getPaymentMethodsSuccess = response => ({
  type: PAY_APPLY_GET_PAYMENT_METHODS,
  response,
})

const getPaymentMethodCostAlternativesSuccess = response => ({
  type: PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS,
  response,
})

const getStorePaymentMethodsSuccess = response => ({
  type: PAY_APPLY_GET_STORE_PAYMENT_METHODS,
  response,
})

const getPaymentPerMonthSuccess = response => ({
  type: PAY_APPLY_GET_PAYMENT_PER_MONTH,
  response,
})

const PaymentPerMonthCostSuccess = response => ({
  type: PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS,
  response,
})

const applicationFormSpec = response => ({
  type: PAY_APPLY_FORM_SPEC,
  response,
})

export const createApplicationSuccess = response => ({
  type: PAY_APPLY_CREATE_APPLICATION_SUCCESS,
  response,
})

const applyApplicationSuccess = response => ({
  type: PAY_APPLY_APPLY_APPLICATION_SUCCESS,
  response,
})

export const createPaymentSuccess = response => ({
  type: PAY_APPLY_CREATE_PAYMENT_SUCCESS,
  response,
})

const authorizePaymentSuccess = response => ({
  type: PAY_APPLY_AUTH_PAYMENT_SUCCESS,
  response,
})

const debitPaymentSuccess = response => ({
  type: PAY_APPLY_DEBIT_PAYMENT_SUCCESS,
  response,
})

const setPaymentData = paymentData => ({
  type: PAY_APPLY_SET_PAYMENT_DATA,
  paymentData,
})

const skipSigningSuccess = () => ({
  type: PAY_APPLY_SKIP_SIGNING,
})

const signingUpdate = status => ({
  type: PAY_APPLY_SIGNING_STATUS,
  status,
})
const identificationUpdate = status => ({
  type: PAY_APPLY_IDENTIFICATION_STATUS,
  status,
})

const redirectionDataSuccess = url => ({
  type: PAY_APPLY_REDIRECTION_DATA_SUCCESS,
  url,
})

const clearRedirection = {
  type: PAY_APPLY_CLEAR_REDIRECTION,
}

const getPendingApplicationsSuccess = data => ({
  type: PAY_APPLY_PENDING_APPLICATIONS_SUCCESS,
  data,
})

const preparePendingApplicationSuccess = response => ({
  type: PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS,
  response,
})

const preparePendingPaymentSuccess = response => ({
  type: PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS,
  response,
})

export const setFormSpecData = data => ({
  type: PAY_APPLY_FORM_SPEC_DATA,
  data,
})

export const newPageLoading = status => ({
  type: PAY_APPLY_NEW_PAGE_LOADING,
  status,
})

export const setPeriodOfRepayment = period => ({
  type: PAY_APPLY_SET_PERIOD_OF_REPAYMENT,
  period,
})

export const costLoading = status => ({
  type: PAY_APPLY_COST_LOADING,
  status,
})

export const onPageLoading = status => ({
  type: PAY_APPLY_ON_PAGE_LOADING,
  status,
})

export const fatalError = response => ({
  type: PAY_APPLY_FATAL_ERROR,
  response,
})

export const setManualIdentification = () => ({
  type: PAY_APPLY_MANUAL_IDENTIFICATION,
})

export const setPaperSign = () => ({
  type: PAY_APPLY_PAPER_SIGN,
})

const setPushedOut = {
  type: PAY_APPLY_PUSHED_OUT_TO_CUSTOMER,
}

export const setAutomaticDebit = automaticDebit => ({
  type: PUSH_OUT_AUTOMATIC_DEBIT,
  automaticDebit,
})

export const initPayApplyWizard = () => ({
  type: PAY_APPLY_INIT,
})

export const resetCostAlternatives = () => ({
  type: PAY_APPLY_RESET_COST_ALTERNATIVES,
})

const signingFailed = () => ({
  type: PAY_APPLY_FAILED_SIGNING,
})

const identificationFailed = () => ({
  type: PAY_APPLY_FAILED_IDENTIFICATION,
})

export const setOrder = order => ({
  type: PAY_APPLY_SET_ORDER,
  order,
})

export const setDebitAmount = debitAmount => ({
  type: PAY_APPLY_SET_DEBIT_AMOUNT,
  debitAmount,
})

export const setDebitReference = debitReference => ({
  type: PAY_APPLY_SET_DEBIT_REFERENCE,
  debitReference,
})

const getPaymentSuccess = response => ({
  type: PAY_APPLY_GET_PAYMENT,
  response,
})

const getApplicationSuccess = response => ({
  type: PAY_APPLY_GET_APPLICATION,
  response,
})

export const resetCurrentPaymentMethod = () => ({
  type: PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD,
})

const getCustomerTypesSuccess = response => ({
  type: PAY_APPLY_CUSTOMER_TYPE,
  response,
})

export const getApplication = (id, onPageLoad) => dispatch => {
  if (onPageLoad) {
    dispatch(onPageLoading(true))
  }
  return dispatch(request(paymentEngineApi.application.get, id))
    .then(response => {
      dispatch(getApplicationSuccess(response))
      if (onPageLoad) {
        dispatch(onPageLoading(false))
      }
      return response
    })
    .catch(error => {
      silentError(error)
      if (onPageLoad) {
        dispatch(onPageLoading(false))
      }
    })
}

export const getPayment = (id, onPageLoad) => dispatch => {
  if (onPageLoad) {
    dispatch(onPageLoading(true))
  }
  return dispatch(request(paymentEngineApi.payment.get, id))
    .then(response => {
      dispatch(getPaymentSuccess(response))
      if (onPageLoad) {
        dispatch(onPageLoading(false))
      }
      return response
    })
    .catch(error => {
      silentError(error)
      if (onPageLoad) {
        dispatch(onPageLoading(false))
      }
    })
}

export const getApplicationOrPayment = idAndType => (dispatch, getState) => {
  const { id, type } = idAndType || getState().payApply.current
  if (type === PayApplyType.PAYMENT) {
    return dispatch(request(paymentEngineApi.payment.get, id)).catch(error =>
      silentError(error),
    )
  }
  return dispatch(request(paymentEngineApi.application.get, id)).catch(error =>
    silentError(error),
  )
}

export const getPendingApplications =
  ({ governmentId, customerType }) =>
  (dispatch, getState) => {
    return dispatch(
      request(
        unusedApplicationsApi.getPendingApplications,
        {
          channelType: 'MERCHANT_PORTAL',
          customerType,
          governmentId,
        },
        getState().auth.token,
      ),
    )
      .then(data => {
        dispatch(getPendingApplicationsSuccess(data))
      })
      .catch(error => {
        silentError(error)
        unableToRetrievePendingApplicationError()
      })
  }

const sortAndFilterMethods = (list, isResursAdmin) => {
  const enabledMethods = list.filter(method => {
    return (
      ((isResursPaymentMethod(method.type) ||
        isEnabledPspPaymentMethod(method.type)) &&
        !method.status.disabled) ||
      (method.status.disabled &&
        method.status.disabledReasons.some(reason =>
          [
            PaymentMethodsStatuses.NOT_ALLOWED_FOR_CUSTOMER,
            PaymentMethodsStatuses.NO_CARD_ON_ACCOUNT,
          ].includes(reason),
        ))
    )
  })
  const filteredExisting = enabledMethods
    .filter(method => isExistingAccountPaymentMethod(method))
    .map(filteredMethod => {
      let accounts = []
      if (
        filteredMethod.availableCards &&
        filteredMethod.availableCards.length > 0
      ) {
        accounts = filteredMethod.availableCards.map(card => ({
          existingNumber:
            filteredMethod.customerType === CustomerTypeModel.LEGAL
              ? card.accountNumber
              : card.cardNumber || card.accountNumber,
          ...card,
        }))
      } else if (
        filteredMethod.availableAccounts &&
        filteredMethod.availableAccounts.length > 0
      ) {
        accounts = filteredMethod.availableAccounts.map(account => ({
          existingNumber: account.accountNumber,
          ...account,
        }))
      }
      const preparedMethod = {
        accounts,
        ...(isExistingPartPayment(filteredMethod)
          ? { displayOrder: 99999 }
          : {}),
      }
      return Object.assign(filteredMethod, preparedMethod)
    })

  const existingOtherMethods = enabledMethods
    .filter(method => !isExistingAccountPaymentMethod(method))
    .sort((a, b) => {
      return a.displayOrder > b.displayOrder
        ? 1
        : b.displayOrder > a.displayOrder
        ? -1
        : 0
    })
  const availableMethods = filteredExisting.concat(existingOtherMethods)

  availableMethods.forEach(method => {
    if (
      method.type === PaymentMethods.RESURS_CARD &&
      method.accounts &&
      method.accounts.length > 1
    ) {
      method.accounts.sort((a, b) => {
        return moment(a.expirationDate) - moment(b.expirationDate)
      })
    }
  })
  if (isResursAdmin) {
    const availableIds = availableMethods
      .map(m => m.id)
      .reduce((r, c) => ({ ...r, [c]: c }), {})
    return availableMethods.concat(
      list
        .filter(pm => !availableIds[pm.id])
        .map(pm => ({
          ...pm,
          disabledResurs: true,
          status: {
            ...pm.status,
            ...(!pm.status.disabled && {
              disabled: true,
              disabledReasons: [
                `Not supported in Merchant Portal (Type: ${pm.type})`,
              ],
            }),
          },
        })),
    )
  }

  return availableMethods
}

export const checkPaymentMethodCostAlternatives =
  (amount, paymentMethodId) => dispatch => {
    return dispatch(
      request(
        paymentMethodsPricingServiceApi.getPaymentMethodCostAlternatives({
          amount,
          paymentMethodId,
        }),
      ),
    )
      .then(data => {
        dispatch(getPaymentMethodCostAlternativesSuccess(data))
      })
      .catch(error => silentError(error))
  }

const sortedPaymentMethods = (data, isResursAdmin) => {
  const availableMethods = sortAndFilterMethods(
    data.paymentMethods,
    isResursAdmin,
  )
  const index = availableMethods.findIndex(
    m => m.type === PaymentMethods.RESURS_CARD,
  )
  if (index > 0) {
    availableMethods.splice(0, 0, availableMethods.splice(index, 1)[0])
  }
  return availableMethods.map((pm, i) => ({ ...pm, _index: i }))
}

export const getAutomaticDebitForPayment = () => (dispatch, getState) =>
  dispatch(
    isFranchiseeOrNoRelations(getState())
      ? request(
          representativeServiceApi.getStorePaymentSettings,
          getStoreId(getState()),
        )
      : request(
          representativeServiceApi.getRepresentativePaymentSettings,
          getRepresentativeId(getState()),
        ),
  )
    .then(({ automaticDebit }) => dispatch(setAutomaticDebit(automaticDebit)))
    .catch(error => {
      genericError(error)
      throw error
    })

export const getPaymentMethods =
  ({ governmentId, customerType }, newPageLoad, onPageLoad) =>
  (dispatch, getState) => {
    if (newPageLoad) {
      dispatch(newPageLoading(true))
    }
    if (onPageLoad) {
      dispatch(onPageLoading(true))
    }
    return dispatch(
      request(paymentMethodsApi.getPaymentMethods, {
        governmentId,
        customerType,
      }),
    )
      .then(data => {
        dispatch(
          getPaymentMethodsSuccess(
            sortedPaymentMethods(data, isUserResursAdmin(getState())),
          ),
        )
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
      })
      .catch(error => {
        dispatch(fatalError(error))
        genericError()
        silentError(error)
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
        throw error
      })
  }

export const getCoApplicantInfoAsync =
  governmentId => async (dispatch, getState) => {
    if (!governmentId) {
      return null
    }
    // noinspection UnnecessaryLocalVariableJS
    const response = await dispatch(
      request(customerFinderServiceApi.getAddressInfo, {
        governmentId,
        customerType: CustomerTypeModel.NATURAL,
        countryCode: getState().storeInfo.currentRepresentative.country,
      }),
    ).catch(error => {
      genericError()
      dispatch(onPageLoading(false))
      silentError(error)
      return null
    })
    return response
  }

export const getCoApplicantInfo = governmentId => (dispatch, getState) => {
  if (!governmentId) {
    return dispatch(setCoApplicantInfo(null))
  }
  dispatch(onPageLoading(true))

  return dispatch(
    request(customerFinderServiceApi.getAddressInfo, {
      governmentId,
      customerType: CustomerTypeModel.NATURAL,
      countryCode: getState().storeInfo.currentRepresentative.country,
    }),
  )
    .then(data => {
      dispatch(setCoApplicantInfo(data))
      dispatch(onPageLoading(false))
    })
    .catch(error => {
      genericError()
      dispatch(onPageLoading(false))
      silentError(error)
      throw error
    })
}

export const reloadCustomerInfo = () => (dispatch, getState) => {
  const countryCode = getState().storeInfo.currentRepresentative.country
  const governmentId = getState().payApply.current.governmentId
  const customerType =
    getState().payApply.current.selectedPaymentMethod.customerType

  return dispatch(
    request(customerFinderServiceApi.getAddressInfo, {
      countryCode,
      governmentId,
      customerType,
    }),
  )
    .catch(error => {
      if (error.status === 404) {
        return {
          governmentId,
          customerType,
          countryCode,
        }
      }
      silentError(error)
      throw error
    })
    .then(data => {
      dispatch(getAddressInfoSuccess(data))

      return Promise.all([
        dispatch(
          getPendingApplications({
            governmentId: data.governmentId,
            customerType,
          }),
        ),
        dispatch(
          getPaymentMethods(
            { governmentId: data.governmentId, customerType },
            false,
          ),
        ),
      ]).catch(error => {
        genericError()
        silentError(error)
        dispatch(newPageLoading(false))
        throw error
      })
    })
    .catch(error => {
      if (error.status === 400 && error.data.code === 'INVALID_GOVERNMENT_ID') {
        notify(
          NOTIFY_DANGER,
          getText('payApply.applicant.governmentIdNotValidError'),
        )

        throw error
      } else {
        silentError(error)
        genericError()
        throw error
      }
    })
}

export const getCustomerInfo =
  (governmentId, customerType) => (dispatch, getState) => {
    dispatch(setCustomerType(customerType))
    dispatch(setGovernmentId(governmentId))
    dispatch(newPageLoading(true))

    const countryCode = getState().storeInfo.currentRepresentative.country
    return dispatch(
      request(customerFinderServiceApi.getAddressInfo, {
        countryCode,
        governmentId,
        customerType,
      }),
    )
      .catch(error => {
        if (error.status === 404) {
          return {
            governmentId,
            customerType,
            countryCode,
          }
        }
        silentError(error)
        throw error
      })
      .then(data => {
        dispatch(getAddressInfoSuccess(data))

        return Promise.all([
          dispatch(
            getPendingApplications({
              governmentId: data.governmentId,
              customerType,
            }),
          ),
          dispatch(
            getPaymentMethods(
              { governmentId: data.governmentId, customerType },
              false,
            ),
          ),
        ])
          .then(() => {
            dispatch(newPageLoading(false))
          })
          .catch(error => {
            genericError()
            silentError(error)
            dispatch(newPageLoading(false))
            throw error
          })
      })
      .catch(error => {
        if (
          error.status === 400 &&
          error.data.code === 'INVALID_GOVERNMENT_ID'
        ) {
          notify(
            NOTIFY_DANGER,
            getText('payApply.applicant.governmentIdNotValidError'),
          )

          dispatch(newPageLoading(false))
          throw error
        } else {
          genericError()
          silentError(error)
          dispatch(newPageLoading(false))
          throw error
        }
      })
  }

const getApplicationFormSpec = (paymentMethodId, amount) => dispatch => {
  return dispatch(
    request(paymentMethodsApi.application.formSpec, {
      paymentMethodId,
      amount,
    }),
  )
    .then(data => {
      dispatch(applicationFormSpec(data))
      dispatch(newPageLoading(false))
    })
    .catch(error => {
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

export const createApplication = () => (dispatch, getState) => {
  return dispatch(
    request(
      paymentEngineApi.application.create,
      createApplicationRequest(getState().payApply, getState().auth),
    ),
  )
    .then(data => {
      dispatch(createApplicationSuccess(data))
      return data
    })
    .catch(error => {
      genericError()
      throw error
    })
}

export const applyApplication = applicationId => (dispatch, getState) => {
  const applyRequest = {
    applicationId,
    apply: {
      creator: getState().auth.username,
      channelType: 'MERCHANT_PORTAL',
    },
  }

  return dispatch(request(paymentEngineApi.application.apply, applyRequest))
    .then(data => dispatch(applyApplicationSuccess(data)))
    .catch(error => {
      genericError()
      throw error
    })
}

export const updateApplication =
  (applicationId, onPageLoad, newPageLoad) => dispatch => {
    if (onPageLoad) {
      dispatch(onPageLoading(true))
    }
    if (newPageLoad) {
      dispatch(newPageLoading(true))
    }
    return dispatch(applyApplication(applicationId))
      .then(() => {
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
      })
      .catch(error => {
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
        genericError()
        throw error
      })
  }

export const getPendingApplicationOnAccount =
  ({ accountNumber, applicant: governmentId }) =>
  async dispatch =>
    dispatch(
      request(
        paymentEngineApi.getPendingApplicationOnAccount(
          governmentId,
          accountNumber,
        ),
      ),
    ).catch(() => null)

export const createInvoicePayment = () => (dispatch, getState) => {
  return dispatch(
    request(
      paymentEngineApi.payment.create,
      createInvoiceRequest(getState().payApply, getState().auth),
    ),
  )
    .then(data => {
      dispatch(createPaymentSuccess(data))
    })
    .catch(error => {
      genericError()
      throw error
    })
}

export const createPayment = () => (dispatch, getState) => {
  return dispatch(
    request(
      paymentEngineApi.payment.create,
      createPaymentRequest(getState().payApply, getState().auth),
    ),
  )
    .then(data => {
      dispatch(createPaymentSuccess(data))
    })
    .catch(error => {
      genericError()
      throw error
    })
}

export const authorizePayment = paymentId => (dispatch, getState) => {
  const authRequest = {
    paymentId,
    authorize: {
      creator: getState().auth.username,
      type: 'MERCHANT_PORTAL',
    },
  }

  return dispatch(request(paymentEngineApi.payment.authorize, authRequest))
    .then(data => {
      dispatch(authorizePaymentSuccess(data))
    })
    .catch(error => {
      genericError()
      throw error
    })
}

export const updatePayment =
  (paymentId, onPageLoad, newPageLoad) => dispatch => {
    if (onPageLoad) {
      dispatch(onPageLoading(true))
    }
    if (newPageLoad) {
      dispatch(newPageLoading(true))
    }
    return dispatch(authorizePayment(paymentId))
      .then(() => {
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
      })
      .catch(error => {
        if (onPageLoad) {
          dispatch(onPageLoading(false))
        }
        if (newPageLoad) {
          dispatch(newPageLoading(false))
        }
        genericError()
        throw error
      })
  }

export const updatePaymentDebitAmount = (dispatch, getState) => {
  const {
    payment: { paymentResult },
    current: { selectedAmount },
  } = getState().payApply

  if (
    !selectedAmount ||
    paymentResult.payment.paymentStatus.totalOrderAmount === selectedAmount
  ) {
    return Promise.resolve()
  }

  const {
    cart: {
      cartItems: [orgCartItem],
    },
  } = paymentResult.payment.paymentLog.filter(
    item => item.type === TransactionTypes.CREATE,
  )[0]
  const cartRequest = {
    cart: {
      cartItems: [
        {
          description: orgCartItem.description,
          externalId: orgCartItem.externalId,
          quantity: orgCartItem.quantity,
          reference: orgCartItem.reference,
          type: orgCartItem.type,
          unit: orgCartItem.unit,
          vatRate: orgCartItem.vatRate,
          unitPriceIncVat: selectedAmount,
        },
      ],
    },
    channelType: ChannelType.MERCHANT_PORTAL,
    creator: getState().auth.username,
  }
  return dispatch(
    request(paymentEngineApi.payment.replaceCart, {
      paymentId: paymentResult.id,
      request: JSON.stringify(cartRequest),
    }),
  ).then(response => {
    return dispatch(getPaymentSuccess(response))
  })
}

export const finishElectronicSigning = payment => dispatch => {
  return dispatch(
    request(paymentEngineApi.payment.finishESigning, payment),
  ).catch(error => {
    genericError()
    throw error
  })
}

export const debitPayment = paymentId => async (dispatch, getState) => {
  if (getState().payApply.current.status === 'APPROVED') {
    return dispatch(
      request(
        paymentEngineApi.payment.finishESigning,
        getState().payApply.current.id,
      ),
    ).catch(error => {
      genericError()
      throw error
    })
  }

  const debitRequest = {
    paymentId,
    request: debitPaymentRequest(getState().payApply, getState().auth),
  }

  const automaticDebitEnabled =
    getState().payApply.payment.paymentResult.publicSettings.automaticDebit

  if (automaticDebitEnabled) {
    await dispatch(getPayment(paymentId))
    const payment = getState().payApply.payment

    if (payment.paymentResult.payment.debited) {
      return dispatch(debitPaymentSuccess(payment.paymentResult))
    }
  }

  return dispatch(request(paymentEngineApi.payment.debit, debitRequest))
    .then(data => dispatch(debitPaymentSuccess(data)))
    .catch(error => {
      genericError()
      throw error
    })
}

export const applyOrDebit = (dispatch, getState) => {
  const { type: payApplyType, id: paymentModelId } = getState().payApply.current
  switch (payApplyType) {
    case PayApplyType.APPLICATION:
      return dispatch(applyApplication(paymentModelId))
    case PayApplyType.PAYMENT:
      return dispatch(debitPayment(paymentModelId))
    default:
      return null
  }
}

export const continueFlow = dispatch => {
  dispatch(newPageLoading(true))
  return dispatch(applyOrDebit).then(result => {
    dispatch(newPageLoading(false))
    return result
  })
}

const delayedPaymentUpdateDebitReference = (dispatch, getState) => {
  const {
    payment: { paymentResult },
    current: { debitReference },
  } = getState().payApply

  if (!debitReference) {
    return Promise.resolve()
  }
  return dispatch(debitPayment(paymentResult.id))
}

export const delayedPaymentUpdateAmountAndDebitReference = dispatch =>
  dispatch(updatePaymentDebitAmount).then(() =>
    dispatch(delayedPaymentUpdateDebitReference),
  )

export const preparePendingApplication =
  account => async (dispatch, getState) => {
    dispatch(newPageLoading(true))

    if (
      account.channelType === ChannelType.MERCHANT_PORTAL &&
      account.applicationId
    ) {
      try {
        if (account.debitableAmount) {
          await dispatch(getPayment(account.applicationId))
          dispatch(
            preparePendingPaymentSuccess(
              getState().payApply.payment.paymentResult,
            ),
          )
          const {
            application: { signing = {} },
          } = getState().payApply.payment.paymentResult
          if (!['SIGNED', 'SKIPPED'].includes(signing.signingStatus)) {
            return dispatch(continueFlow)
          }
          return dispatch(newPageLoading(false))
        }
        await dispatch(getApplication(account.applicationId))
        const {
          application: { signing = {} },
        } = getState().payApply.application.applicationResult
        if (!['SIGNED', 'SKIPPED'].includes(signing.signingStatus)) {
          await dispatch(applyApplication(account.applicationId))
        }
        dispatch(
          preparePendingApplicationSuccess(
            getState().payApply.application.applicationResult,
          ),
        )
        return dispatch(newPageLoading(false))
      } catch (error) {
        genericError(error)
        dispatch(newPageLoading(false))
        throw error
      }
    }
    return dispatch(
      request(
        unusedApplicationsApi.preparePendingApplication,
        {
          channelType: ChannelType.MERCHANT_PORTAL,
          signingType: 'ELECTRONIC',
          unusedApplicationId: account.id,
        },
        getState().auth.token,
      ),
    )
      .then(data => dispatch(preparePendingApplicationSuccess(data)))
      .then(() => dispatch(continueFlow))
      .catch(error => {
        dispatch(fatalError(error))
        genericError(error)
        dispatch(newPageLoading(false))
        throw error
      })
  }

export const createApplicationOrPayment = formSpecData =>
  function (dispatch, getState) {
    dispatch(setFormSpecData(formSpecData))
    const paymentData = getState().payApply
    const onError = error => {
      genericError()
      silentError(error)
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    }
    switch (paymentData.current.selectedPaymentMethod.type) {
      case PaymentMethods.RESURS_CARD:
      case PaymentMethods.RESURS_NEW_CARD:
      case PaymentMethods.RESURS_PART_PAYMENT:
      case PaymentMethods.RESURS_NEW_REVOLVING_CREDIT:
      case PaymentMethods.RESURS_REVOLVING_CREDIT:
        if (
          paymentData.current.selectedPaymentMethod.id ===
            paymentData.current.debitOnMethodId ||
          isExistingPartPayment(paymentData.current.selectedPaymentMethod)
        ) {
          return dispatch(createPayment())
            .then(() => dispatch(continueFlow))
            .catch(onError)
        }
        return dispatch(createApplication())
          .then(() => dispatch(continueFlow))
          .catch(onError)
      case PaymentMethods.SWISH:
      case PaymentMethods.CARD:
      case PaymentMethods.DEBIT_CARD:
      case PaymentMethods.CREDIT_CARD:
      case PaymentMethods.INTERNET:
        return dispatch(createPayment())
          .then(() => dispatch(continueFlow))
          .then(response => {
            dispatch(newPageLoading(false))
            return response
          })
          .catch(onError)
      case PaymentMethods.RESURS_INVOICE:
        return dispatch(createInvoicePayment())
          .then(() => dispatch(continueFlow))
          .catch(onError)
      default:
        break
    }
    return null
  }

export const selectPendingPaymentMethod = selectedPaymentMethod => dispatch => {
  dispatch({
    type: PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD,
    response: selectedPaymentMethod,
  })
}

export const selectPaymentMethod = paymentData => dispatch => {
  dispatch({
    type: PAY_APPLY_SELECT_PAYMENT_METHOD,
    response: paymentData.selectedPaymentMethod,
  })
}

export const selectPaymentMethodAndSetPaymentData =
  paymentData => (dispatch, getState) => {
    dispatch(newPageLoading(true))
    selectPaymentMethod(paymentData)
    let applicationAmount = 0
    switch (paymentData.selectedPaymentMethod.type) {
      case PaymentMethods.RESURS_CARD:
      case PaymentMethods.RESURS_NEW_CARD:
      case PaymentMethods.RESURS_PART_PAYMENT:
      case PaymentMethods.RESURS_NEW_REVOLVING_CREDIT:
      case PaymentMethods.RESURS_REVOLVING_CREDIT:
        applicationAmount = paymentData.limit
        dispatch(setPaymentData(paymentData))
        break
      case PaymentMethods.RESURS_INVOICE:
        applicationAmount = paymentData.amount
        dispatch(setOrder(paymentData.order))
        break
      case PaymentMethods.SWISH:
      case PaymentMethods.CARD:
      case PaymentMethods.DEBIT_CARD:
      case PaymentMethods.CREDIT_CARD:
      case PaymentMethods.INTERNET:
        dispatch(setPaymentData(paymentData))
        break
      default:
        break
    }

    const currentLimit = paymentData.card
      ? Number(paymentData.card.usableAmount)
      : 0

    if (
      paymentData.selectedPaymentMethod.type ===
        PaymentMethods.RESURS_INVOICE ||
      paymentData.limit > currentLimit
    ) {
      dispatch(
        getApplicationFormSpec(
          paymentData.selectedPaymentMethod.id,
          applicationAmount,
        ),
      ).then(() => {
        if (!getState().payApply.formSpec.formSchema.length) {
          dispatch(createApplicationOrPayment({}))
        } else {
          dispatch(newPageLoading(false))
        }
      })
    } else {
      const response = { elements: [] }

      dispatch(applicationFormSpec(response))

      if (!getState().payApply.formSpec.formSchema.length) {
        dispatch(createApplicationOrPayment({}))
      } else {
        dispatch(newPageLoading(false))
      }
    }
  }

export const skipSigning = id => (dispatch, getState) => {
  if (getState().payApply.current.type === PayApplyType.PAYMENT) {
    return triggerWarningToast('Unsupported action: debit without signature')
  }
  dispatch(newPageLoading(true))
  return dispatch(request(paymentEngineApi.application.skipSigning, id))
    .then(() => {
      dispatch(skipSigningSuccess())
      return dispatch(applyApplication(id)).then(() => {
        dispatch(newPageLoading(false))
      })
    })
    .catch(error => {
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

const getSigningStatusOfPaymentOrApplication = (id, isPayment) => dispatch => {
  let endpoint = paymentEngineApi.application.signingStatus
  if (isPayment) {
    endpoint = paymentEngineApi.payment.signingStatus
  }
  return dispatch(request(endpoint, id))
    .then(status => {
      if (status.signingStatus === 'SIGNED') {
        dispatch(
          signingUpdate({
            signed: true,
            type: 'EID',
          }),
        )
        return dispatch(continueFlow)
      }
      dispatch(signingFailed())
      dispatch(newPageLoading(false))
      return null
    })
    .catch(error => {
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

export const prepareForRedirection =
  (
    force = false,
    localPayApply = null,
    useDigitalAgreement = false,
    preferredCommunication = {},
  ) =>
  (dispatch, getState) => {
    dispatch(clearRedirection)
    const payApply = localPayApply || getState().payApply
    const { id } = payApply.current
    let forceElectronicSigning = force
    if (payApply.current.type === PayApplyType.APPLICATION) {
      if (
        payApply.application.applicationResult.signing &&
        (payApply.application.applicationResult.signing.signingType ===
          'PHYSICAL' ||
          payApply.application.applicationResult.signing.signingStatus ===
            'SKIPPED')
      ) {
        forceElectronicSigning = true
      }
      return dispatch(
        request(
          paymentEngineApi.application.prepareForRedirection(
            id,
            forceElectronicSigning,
            useDigitalAgreement,
            preferredCommunication,
          ),
        ),
      )
        .then(data => {
          if (
            data &&
            Object.keys(data).length === 0 &&
            data.constructor === Object
          ) {
            return dispatch(getSigningStatusOfPaymentOrApplication(id, false))
          }
          return dispatch(redirectionDataSuccess(data))
        })
        .catch(error => {
          genericError()
          throw error
        })
    }
    return dispatch(
      request(
        paymentEngineApi.payment.prepareForRedirection(
          id,
          force,
          useDigitalAgreement,
          preferredCommunication,
        ),
      ),
    )
      .then(data => {
        if (
          data &&
          Object.keys(data).length === 0 &&
          data.constructor === Object
        ) {
          return dispatch(getSigningStatusOfPaymentOrApplication(id, true))
        }
        return dispatch(redirectionDataSuccess(data))
      })
      .catch(error => {
        genericError()
        throw error
      })
  }

export const clearCurrentRedirection = () => dispatch =>
  dispatch(clearRedirection)

export const getApplicationSigningStatus = id => dispatch =>
  dispatch(getSigningStatusOfPaymentOrApplication(id, false))

export const getPaymentSigningStatus = id => dispatch =>
  dispatch(getSigningStatusOfPaymentOrApplication(id, true))

export const pageHalt = () => dispatch => {
  dispatch(newPageLoading(false))
}

const applicationUpdateSigningStatus =
  (applicationId, identificationInfo) => dispatch => {
    return dispatch(
      request(paymentEngineApi.application.updateSigningStatus, {
        id: applicationId,
        statusObj: {
          customer: {
            reference: identificationInfo.refnr,
            type: identificationInfo.type,
          },
          coCustomer: {
            reference: identificationInfo.refnrCoapp,
            type: identificationInfo.typeCoapp,
          },
        },
      }),
    )
      .then(() =>
        dispatch(
          signingUpdate({
            signed: true,
            type: identificationInfo.type,
            ref: identificationInfo.refnr,
          }),
        ),
      )
      .catch(error => {
        genericError()
        dispatch(fatalError(error))
        throw error
      })
  }

const paymentUpdateSigningStatus =
  (paymentId, identificationInfo) => dispatch => {
    return dispatch(
      request(paymentEngineApi.payment.updateSigningStatus, {
        id: paymentId,
        statusObj: {
          customer: {
            reference: identificationInfo.refnr,
            type: identificationInfo.type,
          },
          coCustomer: {
            reference: identificationInfo.refnrCoapp,
            type: identificationInfo.typeCoapp,
          },
        },
      }),
    )
      .then(() =>
        dispatch(
          signingUpdate({
            signed: true,
            type: identificationInfo.type,
            ref: identificationInfo.refnr,
          }),
        ),
      )
      .catch(error => {
        genericError()
        dispatch(fatalError(error))
        dispatch(newPageLoading(false))
        throw error
      })
  }

export const getSigningStatus = (dispatch, getState) => {
  const { id, type } = getState().payApply.current
  dispatch(newPageLoading(true))
  if (type === PayApplyType.APPLICATION) {
    return dispatch(getApplicationSigningStatus(id)).then(() =>
      dispatch(newPageLoading(false)),
    )
  }
  return dispatch(getPaymentSigningStatus(id)).then(() =>
    dispatch(newPageLoading(false)),
  )
}

export const eSign =
  ({ useDigitalAgreement, preferredCommunication } = {}) =>
  dispatch => {
    dispatch(newPageLoading(true))

    return dispatch(updatePaymentDebitAmount)
      .then(() =>
        dispatch(
          prepareForRedirection(
            false,
            null,
            useDigitalAgreement,
            preferredCommunication,
          ),
        ),
      )
      .then(response => {
        dispatch(newPageLoading(false))
        return response
      })
      .catch(error => {
        genericError()
        dispatch(newPageLoading(false))
        throw error
      })
  }

export const signDigitalAgreement = preferredCommunication => dispatch => {
  return dispatch(eSign({ useDigitalAgreement: true, preferredCommunication }))
}

export const paperSign = (id, identificationInfo) => (dispatch, getState) => {
  dispatch(setPaperSign())
  if (getState().payApply.current.type === PayApplyType.APPLICATION) {
    return dispatch(applicationUpdateSigningStatus(id, identificationInfo))
  }
  return dispatch(paymentUpdateSigningStatus(id, identificationInfo))
}

export const paperSignCompleted = () => dispatch => {
  return dispatch(continueFlow).catch(error => {
    genericError()
    dispatch(fatalError(error))
    dispatch(newPageLoading(false))
    throw error
  })
}

export const delayedPaymentCompleted =
  automaticDebitDate => (dispatch, getState) => {
    dispatch(newPageLoading(true))

    const {
      payment: { paymentResult },
    } = getState().payApply

    const payment = {
      ...paymentResult,
      status: ApplicationStatus.SIGNING_REQUEST_SENT,
      automaticDebitDate,
    }
    dispatch(debitPaymentSuccess(payment))

    dispatch(newPageLoading(false))
  }

export const pushOutCompleted = () => (dispatch, getState) => {
  dispatch(newPageLoading(true))

  const {
    current,
    application: { applicationResult } = {},
    payment: { paymentResult } = {},
  } = getState().payApply

  const { APPLICATION } = PayApplyType

  dispatch(
    current.type === APPLICATION
      ? applyApplicationSuccess({
          ...applicationResult,
          ...(applicationResult?.status !==
            ApplicationStatus.SIGNING_REQUIRED && {
            status: ApplicationStatus.APPLICATION_PUSHED_OUT_TO_CUSTOMER,
          }),
        })
      : debitPaymentSuccess({
          ...paymentResult,
          ...(paymentResult?.status !== ApplicationStatus.SIGNING_REQUIRED && {
            status: ApplicationStatus.PAYMENT_PUSHED_OUT_TO_CUSTOMER,
          }),
        }),
  )

  dispatch(newPageLoading(false))
}

export const pushedOutToCustomer = () => dispatch => dispatch(setPushedOut)

export const redirectionCompleted = () => dispatch => {
  return dispatch(continueFlow)
    .then(() => dispatch(clearRedirection))
    .catch(error => {
      dispatch(clearRedirection)
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

export const updatePurchaseAmountAndDebit = dispatch => {
  dispatch(newPageLoading(true))
  return dispatch(updatePaymentDebitAmount)
    .then(() => dispatch(continueFlow))
    .catch(error => {
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

const identify = () =>
  function (dispatch, getState) {
    let id
    if (getState().payApply.payment.paymentResult) {
      id = getState().payApply.payment.paymentResult.id
      return dispatch(
        request(paymentEngineApi.payment.prepareForRedirection(id, false)),
      ).then(data => {
        return dispatch(redirectionDataSuccess(data))
      })
    }
    return null
  }

const getPaymentIdentificationStatus = id => dispatch => {
  return dispatch(request(paymentEngineApi.payment.identificationStatus, id))
    .then(status => {
      if (status.identified) {
        dispatch(
          identificationUpdate({
            identified: true,
            type: 'EID',
          }),
        )
        return dispatch(continueFlow)
      }
      dispatch(identificationFailed())
      dispatch(newPageLoading(false))
      return null
    })
    .catch(error => {
      genericError()
      dispatch(fatalError(error))
      dispatch(newPageLoading(false))
      throw error
    })
}

export const getIdentificationStatus = (dispatch, getState) => {
  const { id, type } = getState().payApply.current
  dispatch(newPageLoading(true))
  if (type === PayApplyType.APPLICATION) {
    // not supported
    return genericError()
  }
  return dispatch(getPaymentIdentificationStatus(id)).then(() =>
    dispatch(newPageLoading(false)),
  )
}

export const eIdentification = () => dispatch => {
  dispatch(newPageLoading(true))

  return dispatch(identify()).catch(error => {
    genericError()
    dispatch(newPageLoading(false))
    throw error
  })
}

export const manualIdentification =
  (paymentId, identificationInfo) => dispatch => {
    dispatch(setManualIdentification())
    dispatch(newPageLoading(true))
    return dispatch(
      request(paymentEngineApi.payment.updateIdentificationStatus, {
        id: paymentId,
        statusObj: {
          reference: identificationInfo.refnr,
          type: identificationInfo.type,
        },
      }),
    )
      .then(() => {
        dispatch(
          identificationUpdate({
            identified: true,
            type: identificationInfo.type,
            ref: identificationInfo.refnr,
          }),
        )
        return dispatch(continueFlow)
      })
      .catch(error => {
        dispatch(identificationFailed())
        genericError()
        dispatch(fatalError(error))
        dispatch(newPageLoading(false))
        throw error
      })
  }

const updatePaymentIdentificationStatus = (paymentId, idInfo) => dispatch => {
  return dispatch(
    request(paymentEngineApi.payment.updateIdentificationStatus, {
      id: paymentId,
      statusObj: {
        reference: idInfo.refnr,
        type: idInfo.type,
      },
    }),
  )
    .then(() => {
      if (idInfo.corefnr) {
        return dispatch(
          request(paymentEngineApi.payment.updateIdentificationStatusCoApp, {
            id: paymentId,
            statusObj: {
              reference: idInfo.corefnr,
              type: idInfo.cotype,
            },
          }),
        )
      }
      return null
    })
    .then(() => {
      dispatch(
        identificationUpdate({
          identified: true,
          type: idInfo.type,
          ref: idInfo.refnr,
        }),
      )
    })
    .catch(error => {
      dispatch(identificationFailed())
      throw error
    })
}

const updateApplicationIdentificationStatus =
  (paymentId, idInfo) => dispatch => {
    return dispatch(
      request(paymentEngineApi.application.updateIdentificationStatus, {
        id: paymentId,
        statusObj: {
          reference: idInfo.refnr,
          type: idInfo.type,
        },
      }),
    )
      .then(() => {
        if (idInfo.corefnr) {
          return dispatch(
            request(
              paymentEngineApi.application.updateIdentificationStatusCoApp,
              {
                id: paymentId,
                statusObj: {
                  reference: idInfo.corefnr,
                  type: idInfo.cotype,
                },
              },
            ),
          )
        }
        return null
      })
      .then(() => {
        dispatch(
          identificationUpdate({
            identified: true,
            type: idInfo.type,
            ref: idInfo.refnr,
          }),
        )
      })
      .catch(error => {
        dispatch(identificationFailed())
        throw error
      })
  }

export const updateIdentificationStatus = idInfo => (dispatch, getState) => {
  const { id, type } = getState().payApply.current
  if (type === PayApplyType.PAYMENT) {
    return dispatch(updatePaymentIdentificationStatus(id, idInfo))
  }
  return dispatch(updateApplicationIdentificationStatus(id, idInfo))
}

export const updateBusinessInformation =
  (applicationId, { owners, cardHolders }) =>
  dispatch => {
    return dispatch(
      request(
        paymentEngineApi.application.updateBusinessInformation(applicationId, {
          businessOwners: owners,
          cardHolders,
        }),
      ),
    )
      .then(() => Promise.resolve())
      .catch(error => {
        genericError()
        throw error
      })
  }

export const printApplicationAgreement = applicationId => dispatch => {
  return dispatch(
    request(agreementServiceApi.getApplicationAgreement, applicationId),
  )
    .then(agreementUrl => agreementUrl)
    .catch(error => {
      genericError()
      throw error
    })
}

export const printPaymentAgreement = paymentId => dispatch => {
  return dispatch(request(agreementServiceApi.getPaymentAgreement, paymentId))
    .then(agreementUrl => agreementUrl)
    .catch(error => {
      genericError()
      throw error
    })
}

export const printAgreement = idAndType => (dispatch, getState) => {
  const { id, type } = idAndType || getState().payApply.current
  if (type === PayApplyType.PAYMENT) {
    return dispatch(printPaymentAgreement(id))
  }
  return dispatch(printApplicationAgreement(id))
}

export const setCurrentStep = stepIndex => ({
  type: PAY_APPLY_SET_STEP,
  stepIndex,
})

export const setCurrentPage = pageIndex => ({
  type: PAY_APPLY_SET_PAGE,
  pageIndex,
})

export const prepareForNextStep = stepIndex => dispatch => {
  if (stepIndex === StepModel.GOVERNMENT_ID) {
    dispatch(initPayApplyWizard())
  }

  return dispatch(setCurrentStep(stepIndex))
}

export const getPaymentPerMonth =
  (method, amount, months = null) =>
  (dispatch, getState) => {
    dispatch(costLoading(true))
    return dispatch(
      request(paymentMethodsPricingServiceApi.paymentPerMonth, {
        method,
        amount,
        months,
        storeId: getStoreId(getState()),
      }),
    )
      .then(data => {
        if (months) {
          dispatch(PaymentPerMonthCostSuccess(data))
        } else {
          dispatch(getPaymentPerMonthSuccess(data))
        }
        dispatch(costLoading(false))
      })
      .catch(error => {
        genericError(error)
        dispatch(costLoading(false))
        throw error
      })
  }

export const cancelSigning = applicationId => dispatch => {
  return dispatch(request(paymentEngineApi.cancelSigning(applicationId)))
    .then(() => Promise.resolve())
    .catch(error => {
      genericError(error)
      throw error
    })
}

const findHighestMonths = costList => {
  return costList.reduce((highestValue, newValue) => {
    return Math.max(
      highestValue.months ? highestValue.months : highestValue,
      newValue.months,
    )
  })
}

export const initialCheckPaymentMethodCostAlternatives =
  (amount, paymentMethodId) => dispatch => {
    return dispatch(
      request(
        paymentMethodsPricingServiceApi.getPaymentMethodCostAlternatives({
          amount,
          paymentMethodId,
        }),
      ),
    )
      .then(data => {
        const highestMonth = findHighestMonths(data.costList)
        dispatch(setPeriodOfRepayment(highestMonth))
        dispatch(getPaymentMethodCostAlternativesSuccess(data))
        dispatch(PaymentPerMonthCostSuccess(data))
        dispatch(getPaymentPerMonth(paymentMethodId, amount, highestMonth))
      })
      .catch(error => silentError(error))
  }

export const getStorePaymentMethods =
  ({ typeFilters, customerType, channel }) =>
  dispatch => {
    return dispatch(
      request(paymentMethodsApi.storePaymentMethods, {
        typeFilters,
        customerType,
        channel,
      }),
    )
      .then(data => {
        return dispatch(
          getStorePaymentMethodsSuccess(
            data.paymentMethods.filter(method => {
              return !method.status.disabled
            }),
          ),
        )
      })
      .catch(error => {
        genericError(error)
        throw error
      })
  }

export const getCustomerTypes = () => dispatch => {
  return dispatch(request(paymentMethodsApi.customerTypes))
    .then(data => {
      return dispatch(getCustomerTypesSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const validateExternalId = externalId => dispatch => {
  return dispatch(
    request(paymentEngineApi.payment.validateExternalId, externalId),
  ).catch(error => {
    genericError(error)
    throw error
  })
}
